import script from "./PermissionEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionEditor.vue?vue&type=script&setup=true&lang=js"

import "./PermissionEditor.vue?vue&type=style&index=0&id=8a740fec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a740fec"]])

export default __exports__